import { css, type Theme } from "@emotion/react";

import { dimensions, helpers } from "@styles";

const disabledOpacityZero = css`
  &:disabled {
    opacity: 0;
  }
`;

/**
 * Muted disabled state for carousels where arrows stay visible (e.g. PDP image modal).
 * Default carousels keep {@link disabledOpacityZero} so disabled prev/next stay hidden until hover.
 */
const disabledNavButtonVisible = css`
  &:disabled {
    cursor: not-allowed;
    opacity: 0.4;
  }
`;

const positionRelative = css`
  position: relative;
  transition: opacity 0.3s ease-out;
`;

const fadeWidth = "64px";

const trailingFade = `linear-gradient(to right, black calc(100% - ${fadeWidth}), rgba(0, 0, 0, 0.4))`;

export const arrowNavWrapper = () => css`
  ${positionRelative}

  > button {
    ${disabledOpacityZero}
  }

  &:hover,
  &:focus {
    > button {
      opacity: 1;

      ${disabledOpacityZero}
    }
  }

  @media (hover: none) and (pointer: coarse) {
    > button {
      display: none;
    }
  }
`;

/** Prev/next stay visible without hovering the wrapper (modal lightbox). */
export const arrowNavWrapperPersistent = () => css`
  ${positionRelative}

  > button {
    ${disabledNavButtonVisible}
  }
`;

export const shadowWrapper = (theme: Theme) => css`
  ${positionRelative}

  &:after {
    ${helpers.scrollFade("90deg", theme)};
    right: 0;
  }

  &:before {
    ${helpers.scrollFade("-90deg", theme)};
    left: 0;
  }
`;

export const showShadow = {
  left: css`
    &:before {
      opacity: 1;
    }
  `,
  right: css`
    &:after {
      opacity: 1;

      @media (max-width: ${dimensions.tabletMax}) {
        right: -1rem;
      }
    }
  `,
};

export const edgeFade = {
  right: css`
    -webkit-mask-image: ${trailingFade};
    mask-image: ${trailingFade};
  `,
};

export const slider = {
  base: css`
    overflow: hidden;
  `,
  overflowItems: css`
    @media (max-width: ${dimensions.tabletMax}) {
      width: 100vw;
      padding-right: 2rem;
    }
  `,
};

export const slidesContainer = {
  base: css`
    display: flex;
    gap: 1rem;
    align-items: center;
  `,
  looping: css`
    > div:last-of-type {
      margin-right: 1rem;
    }
  `,
  fullWidthItems: css`
    > div {
      width: 100%;
    }
  `,
};
